import { getAuthCode } from "./getAuthCode";

export const createIdeaImageWithAI = async (SetIsError, SetErrorMessage, id) => {
  try {
    console.log("send image req for " + id);
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/createImageWithAI`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({auth_code:await getAuthCode(),"id":id}), // ✅ send as multipart/form-data
    });

    if (!response.ok) {
      throw new Error("Upload failed");
      return false
    }

    const result = await response.json();
    console.log("Upload success:", result);
    window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'image_created',
    });
    SetIsError(false);
    SetErrorMessage("");
    return result.imagePath;
  } catch (err) {
    SetIsError(true);
    SetErrorMessage(err.message);
    return false
  }
};